import {makeAutoObservable} from 'mobx';
import {RootStore} from './RootStore';
import AdminApiManager from 'services/API/AdminApi/AdminApiManager';
import {
  CreateGroupData,
  GroupInfoResponse,
  StudentData,
  UpdateGroupData,
} from 'services/API/AdminApi/AdminApiModels';
import {GroupType, PersonalData} from 'models/Admin';
import {AdminGroupsStudentsStore} from './AdminGroupStudentsStore';

export interface IAdminGroupsStore {
  groups: GroupType[];

  getGroups(): Promise<void>;
  deleteGroup(groupId: string): Promise<void>;
  updateGroups(body: UpdateGroupData): Promise<void>;
  createGroup(body: CreateGroupData): Promise<void>;
}

export class AdminGroupsStore implements IAdminGroupsStore {
  private adminApiManager = new AdminApiManager();
  private rootStore: RootStore;

  groups: GroupType[] = [];

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
  setGroups = (data: GroupType[]) => {
    this.groups = data;
  };

  findIndexOfGroup = (predicate: string, groups: GroupType[] = this.groups) => {
    return groups.findIndex(item => {
      return item.id === predicate;
    });
  };

  getGroupById = (predicate: string) => {
    return this.groups[this.findIndexOfGroup(predicate)];
  };

  addTemplateGroup = (id: string) => {
    this.groups.push({
      name: '',
      id,
      students: [
        {
          name: '',
          surname: '',
          email: '',
          id: '',
          tenantId: '',
          role: '',
          image: '',
        },
      ],
    });
  };

  async getGroups() {
    this.rootStore.loaderStore.startLoading();

    try {
      const response = await this.adminApiManager.getGroups();
      let groups: GroupType[] = [];
      response.forEach(item => {
        groups.push({name: item.name, id: item.id, students: []});
      });

      this.setGroups(groups);
    } catch (error) {
      console.log(error);
    } finally {
      this.rootStore.loaderStore.stopLoading();
    }
  }

  async deleteGroup(groupId: string) {
    let filteredGroups = this.groups.filter(item => item.id !== groupId);
    this.setGroups(filteredGroups);
    try {
      await this.adminApiManager.deleteGroup(groupId);
    } catch (error) {
      console.log(error);
    }
  }

  async createGroup(body: CreateGroupData) {
    try {
      await this.adminApiManager.createGroup(body);
    } catch (error) {
      console.log(error);
    }
  }

  async updateGroups(body: GroupType) {
    try {
      await this.adminApiManager.updateGroup(body);
    } catch (error) {
      console.log(error);
    }
  }
}
